/**
 * Datos estáticos de "Servicios en Ruta" (Servicentros + Comercio).
 *
 * Fuente: información enviada por el cliente ("INFORMACION UTIL RUTA 68 - E.docx").
 * Solo cubre Ruta 68. Ruta 78 queda sin datos hasta que el cliente los provea.
 *
 * Modela el mismo shape que `docs/SERVICIOS_EN_RUTA_API_SPEC.md` (mayo 2026),
 * con dos extensiones deliberadas mientras no existe backend:
 *   - `direction` (el dato del cliente viene separado por sentido)
 *   - `km` opcional (no todos los puntos traían kilómetro exacto)
 * Cuando se congele el contrato OpenAPI para /api/v1/services, decidir si estas
 * extensiones entran a la spec o si `direction` se deriva de otra forma.
 */

export type ServiceCategory =
  | 'fuel'
  | 'food'
  | 'restroom'
  | 'rest_area'
  | 'market'
  | 'scenic'
  | 'mechanic'
  | 'pharmacy'
  | 'ev_charging';

export type RouteId = '68' | '78';
export type ServiceDirection = 'santiago-litoral' | 'litoral-santiago';

export interface Service {
  id: string;
  name: string;
  route_id: RouteId;
  category: ServiceCategory;
  direction?: ServiceDirection;
  km?: number;
  phone?: string;
  description?: string;
  is_verified: boolean;
}

/** Fecha en que el cliente confirmó estos datos (para el badge de frescura en UI). */
export const SERVICES_VERIFIED_AT = '2026-08-09';

export const SERVICES: Service[] = [
  // ─── Servicentros — sentido Santiago → Litoral ───────────────────────────
  {
    id: 'copec-sector-caren',
    name: 'Copec Sector Caren',
    route_id: '68',
    category: 'fuel',
    direction: 'santiago-litoral',
    description: 'Pronto Copec · servicios higiénicos · cafetería · cajero automático · servicios para viajeros',
    is_verified: true,
  },
  {
    id: 'shell-caren',
    name: 'Shell Caren',
    route_id: '68',
    category: 'fuel',
    direction: 'santiago-litoral',
    km: 18.5,
    description: 'Tienda · servicios higiénicos · comida rápida · cargadores para vehículos eléctricos · cajero automático',
    is_verified: true,
  },
  {
    id: 'copec-voltex-pudahuel',
    name: 'Copec Voltex Charging — Pudahuel',
    route_id: '68',
    category: 'ev_charging',
    direction: 'santiago-litoral',
    km: 17,
    description: 'Punto de carga para vehículos eléctricos',
    is_verified: true,
  },

  // ─── Servicentros — sentido Litoral → Santiago ───────────────────────────
  {
    id: 'shell-placilla',
    name: 'Shell Placilla',
    route_id: '68',
    category: 'fuel',
    direction: 'litoral-santiago',
    km: 98.1,
    description: 'Tienda · comida rápida · cajero automático · servicios higiénicos',
    is_verified: true,
  },
  {
    id: 'copec-placilla',
    name: 'Copec Placilla',
    route_id: '68',
    category: 'fuel',
    direction: 'litoral-santiago',
    km: 105,
    description: 'Restaurante · tiendas · cajero automático · servicios higiénicos',
    is_verified: true,
  },
  {
    id: 'copec-curacavi',
    name: 'Copec Curacaví',
    route_id: '68',
    category: 'fuel',
    direction: 'litoral-santiago',
    km: 53,
    is_verified: true,
  },
  {
    id: 'copec-voltex-curauma',
    name: 'Copec Voltex Charging — Curauma',
    route_id: '68',
    category: 'ev_charging',
    direction: 'litoral-santiago',
    km: 105,
    description: 'Punto de carga para vehículos eléctricos · Tesla Supercharger',
    is_verified: true,
  },

  // ─── Comercio (catálogo incompleto — el cliente seguirá enviando más) ───
  {
    id: 'farmacia-ahumada-r68',
    name: 'Farmacia Ahumada',
    route_id: '68',
    category: 'pharmacy',
    is_verified: true,
  },
  {
    id: 'mcdonalds-r68',
    name: "McDonald's",
    route_id: '68',
    category: 'food',
    is_verified: true,
  },
];
